module.exports = __webpack_public_path__ + "static/media/Historial2.dbf14c46.png";